import { ToastState } from './types'

export const INITIAL_STATE = (): ToastState => ({
  toasts: []
})
